import { Theme } from '@eversports/react-components/design-tokens/theme'
import UserWrapper from '@eversports/react-components/patterns/UserWrapper'
import BaseLink from '@eversports/react-components/primitives/BaseLink'
import Flex from '@eversports/react-components/primitives/Flex'
import Heading from '@eversports/react-components/primitives/Heading'
import Icon from '@eversports/react-components/primitives/Icon'
import SecurityIcon from '@eversports/react-components/primitives/Icon/custom-icons/Security'
import Logo from '@eversports/react-components/primitives/Logo'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { Localized } from '../../localization/react'

interface Props {
  username?: string
  avatar?: string
  goBackToWebsite?: string
  goToMyProfile?: string
  isVenueBrandingEnabled?: boolean
}

export const HEADER_HEIGHT = 56

const useStyles = makeStyles((theme: Theme) => ({
  container: ({ isActive }: { isActive: boolean }) => ({
    height: HEADER_HEIGHT,
    boxShadow: theme.shadows[0],
    background: isActive ? theme.palette.primary.main : theme.palette.subtleText,
    color: isActive ? theme.palette.white : theme.palette.alternativeText,
    paddingRight: theme.layoutSpacing.default,
    paddingLeft: theme.layoutSpacing.default,
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.layoutSpacing.wide,
      paddingLeft: theme.layoutSpacing.wide,
    },
  }),
  displayDesktop: {
    display: 'block',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  displayMobile: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  cursor: {
    cursor: 'auto',
  },
}))

const HeaderComponent = ({
  username,
  avatar,
  goBackToWebsite,
  goToMyProfile,
  isVenueBrandingEnabled = false,
}: Props) => {
  const isActive = !isVenueBrandingEnabled && Boolean(goBackToWebsite && goToMyProfile)
  const classes = useStyles({ isActive })

  return (
    <Flex justifyContent="space-between" alignItems="center" className={classes.container}>
      {goBackToWebsite ? (
        <BaseLink to={goBackToWebsite} external>
          <Logo type="icon" height="24px" color="white" className={classes.displayMobile} />
          <Logo type="horizontal" height="24px" color="white" className={classes.displayDesktop} />
        </BaseLink>
      ) : (
        <>
          <Logo type="icon" height="24px" color="white" className={classes.displayMobile} />
          <Logo type="horizontal" height="24px" color="white" className={classes.displayDesktop} />
        </>
      )}
      <Flex alignItems="center">
        <Icon icon={SecurityIcon} color="white" marginRight="dense" className={classes.displayDesktop} />
        <Heading is="h1" color="white" textTransform="uppercase" className={classes.displayDesktop}>
          <Localized id="header-secure-checkout" />
        </Heading>
        <Heading is="h1" color="white" variant="small" textTransform="uppercase" className={classes.displayMobile}>
          <Localized id="header-secure-checkout" />
        </Heading>
      </Flex>
      {username &&
        (goToMyProfile ? (
          <BaseLink to={goToMyProfile} external>
            <UserWrapper name={username} avatar={avatar} />
          </BaseLink>
        ) : (
          <UserWrapper name={username} avatar={avatar} disabled />
        ))}
    </Flex>
  )
}

export default HeaderComponent
